__turbopack_context__.v({
  "containsDualList": "header-desktop-menu-module-scss-module__2lxG-W__containsDualList",
  "megaMenuContainer": "header-desktop-menu-module-scss-module__2lxG-W__megaMenuContainer",
  "megaMenuFooter": "header-desktop-menu-module-scss-module__2lxG-W__megaMenuFooter",
  "menu-list-desktop": "header-desktop-menu-module-scss-module__2lxG-W__menu-list-desktop",
  "menuBottomContent": "header-desktop-menu-module-scss-module__2lxG-W__menuBottomContent",
  "menuDesktopBanner": "header-desktop-menu-module-scss-module__2lxG-W__menuDesktopBanner",
  "menuDesktopContent": "header-desktop-menu-module-scss-module__2lxG-W__menuDesktopContent",
  "menuDesktopContentWrapper": "header-desktop-menu-module-scss-module__2lxG-W__menuDesktopContentWrapper",
  "menuDesktopImageContent": "header-desktop-menu-module-scss-module__2lxG-W__menuDesktopImageContent",
  "menuHeading": "header-desktop-menu-module-scss-module__2lxG-W__menuHeading",
});
